<template>
  <div class="dynamic-cohort-preview">
    <div class="preview-header">
      <span class="fc-000000 fs-20 fw-900">
        {{ preview.count || 0 }} {{ $t('members.members') }}
      </span>
    </div>

    <div v-if="loading" class="preview-loading">
      <div class="center py-40">
        <div
          v-for="item in [1, 2, 3, 4, 5]"
          :key="'preview_skeleton_' + item"
          :class="{
            'opa-01': item == 5,
            'opa-02': item == 4,
            'opa-04': item == 3,
            'opa-06': item == 2,
          }"
          class="preview-skeleton-item"
        >
          <div class="image-skeleton image-profile-42"></div>
          <div class="preview-skeleton-text">
            <div class="fw-700 fs-14 text-skeleton mt-4" style="width: 120px">&nbsp;</div>
            <div class="fw-500 fs-12 text-skeleton mt-2" style="width: 180px">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="preview.count === 0" class="preview-empty">
      <div class="flex-mid" style="height: 400px">
        <div>
          <div class="center mb-20">
            <img src="../../../assets/images/cohorts/add_user.png" />
          </div>
          <div class="fc-000000 opa-02 fw-900 fs-20 center">
            {{ $t('members.No_members_match') }}
          </div>
        </div>
      </div>
    </div>

    <div v-else class="preview-content">
      <el-table
        :data="preview.members"
        style="width: 100%"
        empty-text="No members match"
        max-height="760px"
        class="el-table-thin-scrollbar"
      >
        <el-table-column width="58">
          <template slot-scope="scope">
            <div class="divMember">
              <div v-if="scope.row.pic">
                <img
                  v-lazy="scope.row.pic"
                  :key="scope.row.pic"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  class="image-skeleton image-profile-42"
                  :class="[blurMode ? 'blurelement' : '']"
                />
              </div>
              <div v-else class="image image-profile-42" :class="[blurMode ? 'blurelement' : '']">
                <div class="text-in-image text-in-image-42 flex-mid">
                  {{
                    $utils('acronymName', {
                      firstName: scope.row.firstname,
                      lastName: scope.row.lastname,
                    })
                  }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('members.Members')" min-width="200">
          <template slot-scope="scope">
            <div style="display: flex; flex-direction: column">
              <span
                class="text-name"
                :class="[blurMode ? 'blurelement' : '']"
              >
                {{ scope.row.firstname }} {{ scope.row.lastname }}
              </span>
              <span class="text-email" :class="[blurMode ? 'blurelement' : '']">
                {{ scope.row.email }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('members.Team')" min-width="160">
          <template slot-scope="scope">
            <span class="fc4A4A4A fs-14 ellipsis" :class="[blurMode ? 'blurelement' : '']">
              {{ scope.row.team_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('members.Status')" align="center" width="90">
          <template slot-scope="scope">
            <div class="div-active">
              <div class="btn-status" :class="[`status-${scope.row.status}`]">
                {{ scope.row.status }}
              </div>
              <div class="active">{{ scope.row.to_now }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicCohortPreview',
  props: {
    preview: {
      type: Object,
      default: () => ({
        count: 0,
        members: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    blurMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.dynamic-cohort-preview {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  .preview-header {
    margin-bottom: 12px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    
    .fc-000000 {
      font-weight: 900;
      font-size: 17px;
    }
  }

  .preview-loading {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    background-color: #fafafa;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    
    .member-skeleton {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px;
      margin-bottom: 8px;
      background-color: #ffffff;
      border-radius: 6px;

      .preview-skeleton-text {
        flex: 1;
      }
    }
  }

  .preview-empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background-color: #fafafa;
    border: 1px dashed #d0d0d0;
    border-radius: 8px;
    
    img {
      opacity: 0.6;
    }
  }

  .preview-content {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    background-color: #ffffff;
    
    .el-table {
      flex: 1;
      min-height: 0;
      border-radius: 8px;
    }
  }
}
</style>

